import {
    Table,
    Td,
    Tr,
    Th,
    Tbody,
    Thead,
    Tfoot,
  } from "@chakra-ui/react";
  import Form from "react-bootstrap/Form";
  import Col from "react-bootstrap/Col";
  import Row from "react-bootstrap/Row";
  import { InputGroup, Pagination } from "react-bootstrap";
  import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
  import dateTimeFormat from "jsFunctions/dateTimeFormat";
  import { useEffect, useState } from "react";
  import { TbListDetails } from "react-icons/tb";
import { allPaymentMode } from "components/allForm/PurchaseItem/selectedOptions";
import PaymentReceiptPdf from "components/allForm/SalesInvoiceForm/PaymentReceipt/paymentReceiptPdf";
import { currencySymbolByCode } from "components/allForm/SalesItem/currencyJson";
  
  const DataRow = ({ label, value, type,currency }) => {
    return (
      <>
        <Form.Label>{label}</Form.Label>
        {type === 'Amount'
          ?
          <InputGroup>
        <InputGroup.Text style={{height:'2rem', border:0, background:'lightGray'}}><span className="rupee-symbol">{currencySymbolByCode(currency || "INR")}</span> </InputGroup.Text>
        <Form.Control
              type="text"
              value={value !== "undefined" && value !== "" ? formatAmountIndianRupees(value) : " "}
              disabled
            />
          </InputGroup>
          :
          <Form.Control
            type="text"
            value={value !== "undefined" && value !== "" ? value : " "}
            disabled
          />
        }
      </>
    );
  };
  
  const getPaymentMode=(id)=>{
    const payMod = allPaymentMode.find(opt=> opt.id === id)
    return payMod?.label || ""
  }
  const PaymentRecordInfo = ({ selectedItem, remainingAmount,expenseType,currency}) => {
    const [totalSpentAmount, setTotalSpentAmount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 3; // Number of items to display per page
  
    const [pmtPrfx,setPmtPrfx] = useState({})
    const [paymentData,setPaymentData] = useState({
        crg:"",
        mod: "",
        amt: "",
        ref: "",
        pmtDt: "",
    })
    const [paymentIndex,setPaymentIndex] = useState("")
  
    useEffect(() => {
      if (selectedItem?.pmtRc && selectedItem?.pmtRc.length > 0) {
        const listOfPayment = selectedItem?.pmtRc;
        const calculateTotalAmount = listOfPayment.reduce((acc, current) => {
          if (current && current?.amt && current?.amt !== '') {
            return acc + parseFloat(current.amt);
          } else {
            return acc;
          }
        }, 0);
        setTotalSpentAmount(calculateTotalAmount);
      }
    }, [selectedItem]);
  
    // Calculate pagination details
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = selectedItem.pmtRc?.slice(indexOfFirstItem, indexOfLastItem) || [];
    const pageCount = Math.ceil(selectedItem.pmtRc?.length / itemsPerPage);
    const [openPdf, setOpenPdf] = useState(false)
    const [paymentMode, setPaymentMode] = useState({});

    const handleOpenPdf = (item,autoCount)=>{
      setPaymentIndex(autoCount)
     
      setPaymentData({
        crg:item?.crg,
        mod: item?.mod,
        amt: item?.amt,
        ref: item?.ref,
        pmtDt: item?.pmtDt,
      })
      const payMod = allPaymentMode.find(opt=> opt.id === item.mod)

      setPaymentMode(payMod);
      setPmtPrfx(item?.pyNo)
      setOpenPdf(true)
    }
    return (
      <>
        <Row className="info-row">
          <Col>
            <DataRow
              label="Requested Amount"
              type="Amount"
              value={selectedItem.pyInfo.apAmt}
              currency={currency}
            />
          </Col>
          <Col>
            <DataRow
              label="Approved Amount"
              type="Amount"
              value={selectedItem.pyInfo.apAmt || 0}
              currency={currency}

            />
          </Col>
        </Row>
  
        <Row className="info-row">
          <Col>
            <DataRow
              label="Net Payable Amount"
              type="Amount"
              value={remainingAmount || 0}
              currency={currency}

            />
          </Col>
          <Col className="check-cross-mark">
            <Form.Label>
              <span
                className={
                  selectedItem.pyInfo.sts === 1
                    ? "checkmark"
                    : "crossmark"
                }
              ></span>{" "}
              {selectedItem.pyInfo.sts === 2
                ? "Is requested amount rejected?"
                : "Is requested amount approved?"}
            </Form.Label>
          </Col>
        </Row>
  
        <Row className="info-row">
          <Col>
            <Form.Label>Approve OR Reject Remark</Form.Label>
            <Form.Control
              as="textarea"
              disabled
              rows={4}
              value={selectedItem?.acRmks}
            />
          </Col>
        </Row>
  
        {currentItems.length ? (
          <div className="info-table">
            <Table size="md" className="table-info" variant="striped">
              <Thead>
                <Tr>
                  <Th>No.</Th>
                  <Th>Payment Mode</Th>
                  <Th>Received Amount</Th>
                  <Th>Reference Number</Th>
                  <Th>Date</Th>
                  
                  {<Th>Action</Th>}
                </Tr>
              </Thead>
              <Tbody>
                {currentItems.map((item, index) => (
                  <Tr key={index}>
                    <Td>{indexOfFirstItem + index + 1}</Td>
                    <Td>{getPaymentMode(item?.mod)}</Td>
                    <Td>
                      <span className="rupee-symbol">{currencySymbolByCode(currency || "INR")}</span>{" "}
                      {item?.amt
                        ? formatAmountIndianRupees(Number(item?.amt))
                        : Number(0).toFixed(2)}
                    </Td>
                    <Td>{item?.ref}</Td>
                    <Td>{dateTimeFormat(item?.pmtDt)}</Td>
                    {
                    <Td>
                      <div
                        style={{cursor:'pointer'}}
                        title="Payment Receipt"
                        onClick={() => {
                          handleOpenPdf(item,index);
                        }}
                        className="ledger-icon"
                      > 
                    
                        <TbListDetails />
                      </div>
                    </Td>
                    }
                  </Tr>
                ))}
              </Tbody>
              <Tfoot>
                <Tr>
                  <Th colSpan={2}>Total Received Amount</Th>
                  <Td colSpan={5} className="total-spent">
                    <span className="rupee-symbol">{currencySymbolByCode(currency || "INR")}</span>{" "}
                    {formatAmountIndianRupees(Number(totalSpentAmount))}
                  </Td>
                </Tr>
              </Tfoot>
            </Table>
  
            {/* Pagination Component */}
            <Pagination
              className="justify-content-end"
              style={{ marginTop: "20px" }}
            >
              <Pagination.Prev
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              />
              {Array.from({ length: pageCount }, (_, i) => (
                <Pagination.Item
                  key={i + 1}
                  active={i + 1 === currentPage}
                  onClick={() => setCurrentPage(i + 1)}
                >
                  {i + 1}
                </Pagination.Item>
              ))}
              <Pagination.Next
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, pageCount))
                }
                disabled={currentPage === pageCount}
              />
            </Pagination>
          </div>
        ) : (
          ""
        )}
        {openPdf && (
          <div className="payment-mode-pdf">
            <PaymentReceiptPdf
              isOpen={openPdf}
              expenseData={selectedItem}
              paymentData={{...paymentData,pmtPrfx,paymentMode}}
              autoCount={paymentIndex}
              onClose={() => setOpenPdf(!openPdf)}
              expenseType={expenseType}
              currency={selectedItem?.inCr}
            />
          </div>
        )}
      </>
    );
  }
  
  export default PaymentRecordInfo;
  